import React, {Component} from 'react';
import {connect} from 'react-redux';
import clone from 'clone';
import {Link, withRouter} from 'react-router-dom';
import {Icon, Layout} from 'antd';
import Amplify, {Auth} from 'aws-amplify';
import Scrollbars from '../../components/utility/customScrollBar.js';
import Menu from '../../components/uielements/menu';
import SidebarWrapper from './sidebar.style';
import appActions from '../../redux/app/actions';
import Logo from '../../components/utility/logo';
import ACTLogo from '../assessts/Icons/ACT-coach-logo.png';
import CoachLogo from '../assessts/Icons/DBT-coach-logo.png';
import MICoachLogo from '../assessts/Icons/MI-coach-logo.png';
import CBTLogo from '../assessts/Icons/CBT-companion-logo.png';
import DBT from '../assessts/Icons/DBT-daily-app-icon.png';

/* import AcountActivity from '../assessts/Icons/sidebar/account-activity.png';
import Administration from '../assessts/Icons/sidebar/administration.png';
import Appointment from '../assessts/Icons/sidebar/appointment.png';
import Apps from '../assessts/Icons/sidebar/apps.png';
import Assign from '../assessts/Icons/sidebar/assign.png';
import Bill from '../assessts/Icons/sidebar/bill.png';
import BillingInsurance from '../assessts/Icons/sidebar/billing-ansuarance.png';
import BillingService from '../assessts/Icons/sidebar/billing-service.png';
import ClientCommunication from '../assessts/Icons/sidebar/client-communication.png';
import ClientPortal from '../assessts/Icons/sidebar/client-portal.png';
import Clients from '../assessts/Icons/sidebar/clients.png';
import Coverage from '../assessts/Icons/sidebar/coverage.png';
import Documents from '../assessts/Icons/sidebar/documents.png';
import Help from '../assessts/Icons/sidebar/help.png';
import Insights from '../assessts/Icons/sidebar/insights.png';
import InsurancePayer from '../assessts/Icons/sidebar/insuarance-payer.png';
import List from '../assessts/Icons/sidebar/list.png';
import Notes from '../assessts/Icons/sidebar/notes.png';
import Notification from '../assessts/Icons/sidebar/notifications.png';
import PC from '../assessts/Icons/sidebar/pc.png';
import Population from '../assessts/Icons/sidebar/population.png';
import PracticeDetails from '../assessts/Icons/sidebar/practice-details.png';
import PracticeSettings from '../assessts/Icons/sidebar/practice-settings.png';
import Results from '../assessts/Icons/sidebar/results.png';
import Subscriptions from '../assessts/Icons/sidebar/subscription.png';
import TeamMembers from '../assessts/Icons/sidebar/team-member.png';
import TeleHealth from '../assessts/Icons/sidebar/telehealth.png'; */
import {getCurrentTheme} from '../ThemeSwitcher/config';
import {themeConfig} from '../../config';

import graphql_endpoint from '../../aws-appsync-url';
import {store} from '../../redux/store';
import BTIcon from '../assessts';
import {hasAccessOf, hasAccessOfPlans, routePermission, routesList,} from '../../helpers/permission';
import {getAppsAPI, isOwner} from '../../helpers/helper';

const CryptoJS = require('crypto-js');

const { Sider } = Layout;

const { toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed } = appActions;

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: {},
    };
    this.handleClick = this.handleClick.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
  }

  async componentDidMount() {
    Amplify.configure({
      API: {
        graphql_endpoint: graphql_endpoint.BTPORTAL,
      },
    });

    const { apps } = await getAppsAPI();
    this.setState({ apps });
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      location: { pathname },
    } = this.props;

    if (prevProps.app?.apps !== this.props.app?.apps) {
      this.componentDidMount();
    }

    if (pathname === '/app/profile') {
      return;
    }
    if (
      pathname !== '/app/settings/billing-and-service' &&
      pathname !== '/app/upgrade-plan' &&
      !hasAccessOf(routePermission[pathname])
    ) {
      if (pathname !== '/app/clients') {
        this.props.history.push('/app/clients');
      } else {
        this.props.history.push('/app/appointment');
      }
      return;
    }
    if (
      (await !hasAccessOfPlans(pathname)) &&
      pathname !== '/app/upgrade-plan' &&
      routesList.includes(pathname)
    ) {
      this.props.history.push('/app/upgrade-plan');
    }
  }

  async handleClick(e) {
    if (await hasAccessOfPlans(e.key)) {
      this.props.changeCurrent([e.key]);
      if (this.props.app.view === 'MobileView') {
        setTimeout(() => {
          this.props.toggleCollapsed();
          this.props.toggleOpenDrawer();
        }, 100);
      }
    } else {
      this.props.history.push('/app/upgrade-plan');
    }
  }

  onOpenChange(newOpenKeys) {
    const { app, changeOpenKeys } = this.props;
    const latestOpenKey = newOpenKeys.find(key => !(app.openKeys.indexOf(key) > -1));
    const latestCloseKey = app.openKeys.find(key => !(newOpenKeys.indexOf(key) > -1));
    let nextOpenKeys = [];
    if (latestOpenKey) {
      nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
    }
    if (latestCloseKey) {
      nextOpenKeys = this.getAncestorKeys(latestCloseKey);
    }
    changeOpenKeys(nextOpenKeys);
  }

  getAncestorKeys = key => {
    const map = {
      sub3: ['sub2'],
    };
    return map[key] || [];
  };

  isLockVisible = type => {
    const isLockHide = localStorage.getItem('isLockHide') === 'true' || false;
    return isLockHide && !hasAccessOfPlans(type);
  };

  navigateToEMDRWeb = async () => {
    const user = await Auth.currentAuthenticatedUser({});
    user.getCachedDeviceKeyAndPassword(); // without this line, the deviceKey is null

    const idToken = (await Auth.currentSession()).getIdToken().getJwtToken();
    const accessToken = (await Auth.currentSession()).getAccessToken().getJwtToken();
    const refreshToken = (await Auth.currentSession()).getRefreshToken().getToken();
    const idCipher = CryptoJS.AES.encrypt(
      idToken,
      process.env.REACT_APP_ENCRYPT_DECRYPT_KEY,
    ).toString();
    const deviceKeyCipher = CryptoJS.AES.encrypt(
      user.deviceKey,
      process.env.REACT_APP_ENCRYPT_DECRYPT_KEY,
    ).toString();
    const accessCipher = CryptoJS.AES.encrypt(
      accessToken,
      process.env.REACT_APP_ENCRYPT_DECRYPT_KEY,
    ).toString();
    const refreshCipher = CryptoJS.AES.encrypt(
      refreshToken,
      process.env.REACT_APP_ENCRYPT_DECRYPT_KEY,
    ).toString();
    window.open(
      `https://emdr.resiliens.com/?${idCipher}&=${accessCipher}&=${refreshCipher}&=${deviceKeyCipher}&=${localStorage.getItem(
        'email',
      )}`,
    );
  };

  render() {
    const groups = store.getState().Auth.get('groups');
    const isOnlyCoordinator = groups.length === 1 && groups.includes('coordinators');
    const { url, app } = this.props;
    const customizedTheme = getCurrentTheme('sidebarTheme', themeConfig.theme);
    const collapsed = clone(app.collapsed) && !clone(app.openDrawer);
    const mode = collapsed === true ? 'vertical' : 'inline';
    const styling = {
      backgroundColor: customizedTheme.backgroundColor,
    };
    const submenuColor = {
      color: customizedTheme.textColor,
    };
    const submenuStyle = {
      backgroundColor: 'rgba(0,0,0,0.3)',
      color: customizedTheme.textColor,
    };
    const apps = this.state.apps || {};
    return (
      <SidebarWrapper>
        <Sider
          trigger={null}
          collapsible
          // collapsed={window.innerWidth<1030}
          width={window.innerWidth > 1025 ? '280' : '150'}
          className='isomorphicSidebar bt_portal-side_bar'
          style={styling}
        >
          {app.isAppUpdate ? <></> : null}
          <Logo collapsed={collapsed} />
          <Scrollbars style={{ height: app.height - 70 }}>
            {isOnlyCoordinator ? (
              <Menu
                onClick={this.handleClick}
                theme='light'
                mode={mode}
                openKeys={collapsed ? [] : app.openKeys}
                selectedKeys={app.current}
                defaultOpenKeys={['homework']}
                onOpenChange={this.onOpenChange}
                className='isoDashboardMenu'
              >
                <Menu.Item key='groups'>
                  <Link to={hasAccessOfPlans('Groups') ? `${url}/groups` : `${url}/upgrade-plan`}>
                    <span className='isoMenuHolder anticon' style={submenuColor}>
                      <i className='ion-ios-people' />
                      <span className='nav-text'>Groups</span>
                    </span>
                  </Link>
                </Menu.Item>
                <Menu.ItemGroup
                  key='homework'
                  title={
                    <span className='isoMenuHolder anticon' style={submenuColor}>
                      <i className='ion-ios-book' />
                      <span className='nav-text'>Homework</span>
                    </span>
                  }
                >
                  <Menu.Item style={submenuStyle} key='homework'>
                    <Link
                      to={hasAccessOfPlans('Homework') ? `${url}/homework` : `${url}/upgrade-plan`}
                    >
                      <span className='isoMenuHolder anticon' style={submenuColor}>
                        <i className='ion-ios-alarm' />
                        <span className='nav-text'>Schedule</span>
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item style={submenuStyle} key='homeworkList'>
                    <Link
                      to={
                        hasAccessOfPlans('Homework')
                          ? `${url}/homework-list`
                          : `${url}/upgrade-plan`
                      }
                    >
                      <span className='isoMenuHolder anticon' style={submenuColor}>
                        <i className='ion-android-menu' />
                        <span className='nav-text'>List</span>
                      </span>
                    </Link>
                  </Menu.Item>
                </Menu.ItemGroup>
                <Menu.Item key='help'>
                  <Link to='/help'>
                    <span className='isoMenuHolder anticon' style={submenuColor}>
                      <i className='ion-help-circled' />
                      <span className='nav-text'>Help</span>
                    </span>
                  </Link>
                </Menu.Item>
              </Menu>
            ) : (
              <Menu
                // onClick={e=>this.handleClick(e)}
                onClick={this.handleClick}
                theme='dark'
                mode='inline'
                inlineCollapsed={window.innerWidth < 800}
                openKeys={collapsed ? [] : app.openKeys}
                selectedKeys={[this.props.location.pathname]}
                defaultOpenKeys={[
                  'app1',
                  'homework',
                  'assessmentsMenu',
                  'practice-setting',
                  'billing-and-insurance',
                  'administration-section',
                  'client-communication',
                ]}
                onOpenChange={this.onOpenChange}
                className='isoDashboardMenu'
              >
                {/* { hasAccessOf('Dashboard') &&
                <Menu.Item key='dashboard'>
                  <Link to={`${url}`}>
                    <span className='isoMenuHolder' style={submenuColor}>
                      <BTIcon type='invoice'/>
                      <span className='nav-text'>Dashboard</span>
                    </span>
                  </Link>
                </Menu.Item>} */}

                {hasAccessOf('Clients') && (
                  <Menu.Item key={`${url}/clients`}>
                    <Link to={`${url}/clients`}>
                      <span className='isoMenuHolder anticon' style={submenuColor}>
                        <i>
                          <span
                            className='iconify'
                            data-icon='gridicons:multiple-users'
                            data-inline='false'
                            style={{ marginRight: 15 }}
                          />
                        </i>
                        <span className='nav-text'>Clients</span>
                      </span>
                    </Link>
                  </Menu.Item>
                )}

                {(hasAccessOf('Appointment') || hasAccessOf('SecureMessaging')) && (
                  <Menu.ItemGroup
                    key='client-communication'
                    title={
                      <span className='isoMenuHolder' style={submenuColor}>
                        <Icon type='setting' />
                        <span>Client Communication</span>
                      </span>
                    }
                  >
                    {hasAccessOf('Appointment') && (
                      <Menu.Item
                        key={`${url}/appointment`}
                        hidden={this.isLockVisible(`${url}/appointment`)}
                      >
                        <Link to={`${url}/appointment`}>
                          <span className='isoMenuHolder' style={submenuColor}>
                            <Icon type='reconciliation' />
                            <span className='nav-text'>Appointments</span>{' '}
                            {!hasAccessOfPlans(`${url}/appointment`) ? <Icon type='lock' /> : ''}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}
                    {hasAccessOf('SecureMessaging') && (
                      <Menu.Item
                        key={`${url}/communication`}
                        hidden={this.isLockVisible(`${url}/communication`)}
                      >
                        <Link to={`${url}/communication`}>
                          <span className='isoMenuHolder' style={submenuColor}>
                            <Icon type='inbox' />
                            <span className='nav-text'>Telehealth</span>{' '}
                            {!hasAccessOfPlans(`${url}/communication`) ? <Icon type='lock' /> : ''}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}
                  </Menu.ItemGroup>
                )}

                {hasAccessOf('Apps') ||
                hasAccessOf('Groups') ||
                hasAccessOf('Homework') ||
                hasAccessOf('Assessments') ? (
                  <div className='sidebar-category'>Evidence-based Tools</div>
                ) : null}
                {hasAccessOf('Apps') ? (
                  <Menu.ItemGroup
                    key='app1'
                    title={
                      <span className='isoMenuHolder anticon' style={submenuColor}>
                        <BTIcon type='practiceSetting' />
                        <span className='nav-text'>Apps</span>
                      </span>
                    }
                  >
                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/act-coach`}
                      hidden={!apps.ACT || this.isLockVisible(`${url}/act-coach`)}
                    >
                      <Link style={submenuColor} to={`${url}/act-coach`}>
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <img
                            src={ACTLogo}
                            alt='ACT Coach'
                            style={{ width: '20px', marginRight: '10px' }}
                          />
                          <span className='nav-text'>ACT Coach</span>{' '}
                          {!hasAccessOfPlans(`${url}/act-coach`) ? <Icon type='lock' /> : ''}
                        </span>
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/cbt-companion`}
                      hidden={!apps.CBT || this.isLockVisible(`${url}/cbt-companion`)}
                    >
                      <Link style={submenuColor} to={`${url}/cbt-companion`}>
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <img
                            src={CBTLogo}
                            alt='CBT Companion'
                            style={{ width: '20px', marginRight: '10px' }}
                          />
                          <span className='nav-text'>CBT Companion</span>{' '}
                          {!hasAccessOfPlans(`${url}/cbt-companion`) ? <Icon type='lock' /> : ''}
                        </span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/dbt-coach`}
                      hidden={!apps.COACH || this.isLockVisible(`${url}/dbt-coach`)}
                    >
                      <Link style={submenuColor} to={`${url}/dbt-coach`}>
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <img
                            src={CoachLogo}
                            alt='DBT Coach'
                            style={{ width: '20px', marginRight: '10px' }}
                          />
                          <span className='nav-text'>DBT Coach</span>{' '}
                          {!hasAccessOfPlans(`${url}/dbt-coach`) ? <Icon type='lock' /> : ''}
                        </span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/mi-coach`}
                      hidden={!apps.MI || this.isLockVisible(`${url}/mi-coach`)}
                    >
                      <Link style={submenuColor} to={`${url}/mi-coach`}>
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <img
                            src={MICoachLogo}
                            alt='MI Coach'
                            style={{ width: '20px', marginRight: '10px' }}
                          />
                          <span className='nav-text'>MI Coach</span>{' '}
                          {!hasAccessOfPlans(`${url}/mi-coach`) ? <Icon type='lock' /> : ''}
                        </span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/emdr`}
                      // hidden={!apps.MI || this.isLockVisible(`${url}/mi-coach`)}
                    >
                      <a
                        style={submenuColor}
                        target='_blank'
                        referrerPolicy='no-referrer'
                        onClick={this.navigateToEMDRWeb}
                      >
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <img
                            src={MICoachLogo}
                            alt='EMDR'
                            style={{ width: '20px', marginRight: '10px' }}
                          />
                          <span className='nav-text'>EMDR</span>{' '}
                          {!hasAccessOfPlans(`${url}/mi-coach`) ? <Icon type='lock' /> : ''}
                        </span>
                      </a>
                    </Menu.Item>
                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/dbt-daily`}
                      hidden={!apps.DBT || this.isLockVisible(`${url}/dbt-daily`)}
                    >
                      <Link style={submenuColor} to={`${url}/dbt-daily`}>
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <img
                            src={DBT}
                            alt='DBT Daily'
                            style={{ width: '20px', marginRight: '10px' }}
                          />
                          <span className='nav-text'>DBT Daily</span>{' '}
                          {!hasAccessOfPlans(`${url}/dbt-daily`) ? <Icon type='lock' /> : ''}
                        </span>
                      </Link>
                    </Menu.Item>

                    {/* <Menu.Item style={submenuStyle} key="ifs-companion">
                <Link style={submenuColor} to={`${url}/ifs-companion`}>
                  <span className="isoMenuHolder" style={submenuColor}>
                    <i className="ion-lightbulb" />
                    <span className="nav-text">
                      IFS Companion
                    </span>
                  </span>
                </Link>
              </Menu.Item> */}
                  </Menu.ItemGroup>
                ) : null}
                {hasAccessOf('Groups') && (
                  <Menu.Item
                    key={`${url}/groups`}
                    style={{ marginTop: 10 }}
                    hidden={this.isLockVisible(`${url}/groups`)}
                  >
                    <Link to={`${url}/groups`}>
                      <span className='isoMenuHolder anticon' style={submenuColor}>
                        <BTIcon type='teamMembers' />
                        <span className='nav-text'>Groups</span>{' '}
                        {!hasAccessOfPlans(`${url}/groups`) ? <Icon type='lock' /> : ''}
                      </span>
                    </Link>
                  </Menu.Item>
                )}
                {hasAccessOf('Homework') && (
                  <Menu.ItemGroup
                    key='homework'
                    title={
                      <span className='isoMenuHolder anticon' style={submenuColor}>
                        <BTIcon type='documents' />
                        <span className='nav-text'>Homework</span>
                      </span>
                    }
                  >
                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/homework`}
                      hidden={this.isLockVisible(`${url}/homework`)}
                    >
                      <Link to={`${url}/homework`}>
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <BTIcon type='assign' />
                          <span className='nav-text'>Assign</span>{' '}
                          {!hasAccessOfPlans(`${url}/homework`) ? <Icon type='lock' /> : ''}
                        </span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/homework-list`}
                      hidden={this.isLockVisible(`${url}/homework-list`)}
                    >
                      <Link to={`${url}/homework-list`}>
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <i>
                            <span
                              className='iconify'
                              data-icon='fa-regular:list-alt'
                              style={{ marginRight: 15 }}
                            />
                          </i>
                          <span className='nav-text'>List</span>{' '}
                          {!hasAccessOfPlans(`${url}/homework-list`) ? <Icon type='lock' /> : ''}
                        </span>
                      </Link>
                    </Menu.Item>
                  </Menu.ItemGroup>
                )}
                {hasAccessOf('Assessments') && (
                  <Menu.ItemGroup
                    key='assessmentsMenu'
                    title={
                      <span className='isoMenuHolder anticon' style={submenuColor}>
                        <BTIcon type='administration' />
                        <span className='nav-text'>Assessments</span>
                      </span>
                    }
                  >
                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/assessments/config`}
                      hidden={this.isLockVisible(`${url}/assessments/config`)}
                    >
                      <Link to={`${url}/assessments/config`}>
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <BTIcon type='assign' />
                          <span className='nav-text'>Assign</span>{' '}
                          {!hasAccessOfPlans(`${url}/assessments/config`) ? (
                            <Icon type='lock' />
                          ) : (
                            ''
                          )}
                        </span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/assessments`}
                      hidden={this.isLockVisible(`${url}/assessments`)}
                    >
                      <Link to={`${url}/assessments`}>
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <BTIcon type='results' />
                          <span className='nav-text'>Results</span>{' '}
                          {!hasAccessOfPlans(`${url}/assessments`) ? <Icon type='lock' /> : ''}
                        </span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/assessments/population`}
                      hidden={this.isLockVisible(`${url}/assessments`)}
                    >
                      <Link to={`${url}/assessments/population`}>
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <BTIcon type='clientInsight' />
                          <span className='nav-text'>Population</span>{' '}
                          {!hasAccessOfPlans(`${url}/assessments`) ? <Icon type='lock' /> : ''}
                        </span>
                      </Link>
                    </Menu.Item>
                  </Menu.ItemGroup>
                )}

                <div
                  className='sidebar-category'
                  // hidden={!(hasAccessOf('PracticeDetails') || hasAccessOf('BillingAndServices')) && !(hasAccessOfPlans('PracticeManagement') && hasAccessOfPlans('PracticeDetails'))}
                >
                  Practice Management
                </div>

                {hasAccessOf('Insights') && (
                  <Menu.Item key={`${url}/insights`} hidden={this.isLockVisible(`${url}/insights`)}>
                    <Link to={`${url}/insights`}>
                      <span className='isoMenuHolder anticon' style={submenuColor}>
                        <BTIcon type='insights' />
                        <span className='nav-text'>Insights</span>{' '}
                        {!hasAccessOfPlans(`${url}/insights`) ? <Icon type='lock' /> : ''}
                      </span>
                    </Link>
                  </Menu.Item>
                )}
                {(hasAccessOf('Billing') || hasAccessOf('Coverage')) &&
                  (!this.isLockVisible(`${url}/billings`) ||
                    !this.isLockVisible(`${url}/coverage`)) && (
                    <Menu.ItemGroup
                      key='billing-and-insurance'
                      title={
                        <span className='isoMenuHolder' style={submenuColor}>
                          <BTIcon type='billingInsurance' />
                          <span className=''>Billing and Insurance</span>
                        </span>
                      }
                    >
                      {hasAccessOf('Billing') && (
                        <Menu.Item
                          style={submenuStyle}
                          key={`${url}/billings`}
                          hidden={this.isLockVisible(`${url}/billings`)}
                        >
                          <Link to={`${url}/billings`}>
                            <span className='isoMenuHolder anticon' style={submenuColor}>
                              <BTIcon type='billing' />
                              <span className='nav-text'>Billing</span>{' '}
                              {!hasAccessOfPlans(`${url}/billings`) ? <Icon type='lock' /> : ''}
                            </span>
                          </Link>
                        </Menu.Item>
                      )}
                      {hasAccessOf('Coverage') && (
                        <Menu.Item
                          style={submenuStyle}
                          key={`${url}/coverage`}
                          hidden={this.isLockVisible(`${url}/coverage`)}
                        >
                          <Link to={`${url}/coverage`}>
                            <span className='isoMenuHolder anticon' style={submenuColor}>
                              <BTIcon type='coverage' />
                              <span className='nav-text'>Coverage</span>{' '}
                              {!hasAccessOfPlans(`${url}/coverage`) ? <Icon type='lock' /> : ''}
                            </span>
                          </Link>
                        </Menu.Item>
                      )}
                    </Menu.ItemGroup>
                  )}

                {/* {(hasAccessOf('PracticeDetails') || hasAccessOf('ClientPortal') || hasAccessOf('Notifications') || hasAccessOf('NotesAndForms') || hasAccessOf('Documents') || hasAccessOf('BillingAndServices')) && */}
                {(!this.isLockVisible(`${url}/settings/practice-details`) ||
                  !this.isLockVisible(`${url}/settings/practice-details`) ||
                  !this.isLockVisible(`${url}/settings/billing-and-service`) ||
                  !this.isLockVisible(`${url}/settings/documents`) ||
                  !this.isLockVisible(`${url}/settings/notifications`) ||
                  !this.isLockVisible(`${url}/settings/notesAndForms`) ||
                  !this.isLockVisible(`${url}/settings/client-portal`) ||
                  !this.isLockVisible(`${url}/settings/notesAndForms`) ||
                  !this.isLockVisible(`${url}/settings/insurance-payer`)) && (
                  <Menu.ItemGroup
                    key='practice-setting'
                    title={
                      <span className='isoMenuHolder' style={submenuColor}>
                        <BTIcon type='practiceSetting' />
                        <span className=''>Practice Setting</span>
                      </span>
                    }
                  >
                    {hasAccessOf('PracticeDetails') && (
                      <Menu.Item
                        style={submenuStyle}
                        key={`${url}/settings/practice-details`}
                        hidden={this.isLockVisible(`${url}/settings/practice-details`)}
                      >
                        <Link to={`${url}/settings/practice-details`}>
                          <span className='isoMenuHolder anticon' style={submenuColor}>
                            <BTIcon type='practiceDetails' />
                            <span className='nav-text'>Practice Details</span>{' '}
                            {!hasAccessOfPlans(`${url}/settings/practice-details`) ? (
                              <Icon type='lock' />
                            ) : (
                              ''
                            )}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}
                    {/* {hasAccessOf('BillingAndServices') && */}
                    <Menu.Item
                      style={submenuStyle}
                      key={`${url}/settings/billing-and-service`}
                      hidden={this.isLockVisible(`${url}/settings/billing-and-service`)}
                    >
                      <Link to={`${url}/settings/billing-and-service`}>
                        <span className='isoMenuHolder anticon' style={submenuColor}>
                          <BTIcon type='billingService' />
                          <span className='nav-text'>Billing And Service</span>{' '}
                          {!hasAccessOfPlans(`${url}/settings/billing-and-service`) ? (
                            <Icon type='lock' />
                          ) : (
                            ''
                          )}
                        </span>
                      </Link>
                    </Menu.Item>
                    {/* // } */}
                    {hasAccessOf('Documents') && (
                      <Menu.Item
                        style={submenuStyle}
                        key={`${url}/settings/documents`}
                        hidden={this.isLockVisible(`${url}/settings/documents`)}
                      >
                        <Link to={`${url}/settings/documents`}>
                          <span className='isoMenuHolder anticon' style={submenuColor}>
                            <BTIcon type='documents' />
                            <span className='nav-text'>Documents</span>{' '}
                            {!hasAccessOfPlans(`${url}/settings/documents`) ? (
                              <Icon type='lock' />
                            ) : (
                              ''
                            )}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}
                    {hasAccessOf('Notifications') && (
                      <Menu.Item
                        style={submenuStyle}
                        key={`${url}/settings/notifications`}
                        hidden={this.isLockVisible(`${url}/settings/notifications`)}
                      >
                        <Link to={`${url}/settings/notifications`}>
                          <span className='isoMenuHolder anticon' style={submenuColor}>
                            <BTIcon type='notifications' />
                            <span className='nav-text'>Notifications</span>{' '}
                            {!hasAccessOfPlans(`${url}/settings/notifications`) ? (
                              <Icon type='lock' />
                            ) : (
                              ''
                            )}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}
                    {hasAccessOf('NotesAndForms') && (
                      <Menu.Item
                        style={submenuStyle}
                        key={`${url}/settings/notesAndForms`}
                        hidden={this.isLockVisible(`${url}/settings/notesAndForms`)}
                      >
                        <Link to={`${url}/settings/notesAndForms`}>
                          <span className='isoMenuHolder anticon' style={submenuColor}>
                            <BTIcon type='notesForms' />
                            <span className='nav-text'>Notes & Forms</span>{' '}
                            {!hasAccessOfPlans(`${url}/settings/notesAndForms`) ? (
                              <Icon type='lock' />
                            ) : (
                              ''
                            )}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}
                    {hasAccessOf('ClientPortal') && (
                      <Menu.Item
                        style={submenuStyle}
                        key={`${url}/settings/client-portal`}
                        hidden={this.isLockVisible(`${url}/settings/client-portal`)}
                      >
                        <Link to={`${url}/settings/client-portal`}>
                          <span className='isoMenuHolder anticon' style={submenuColor}>
                            <BTIcon type='clientPortal' />
                            <span className='nav-text'>Client Portal</span>{' '}
                            {!hasAccessOfPlans(`${url}/settings/client-portal`) ? (
                              <Icon type='lock' />
                            ) : (
                              ''
                            )}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}
                    {hasAccessOf('InsurancePayers') && (
                      <Menu.Item
                        style={submenuStyle}
                        key={`${url}/settings/insurance-payer`}
                        hidden={this.isLockVisible(`${url}/settings/insurance-payer`)}
                      >
                        <Link to={`${url}/settings/insurance-payer`}>
                          <span className='isoMenuHolder anticon' style={submenuColor}>
                            <BTIcon type='insurancePayers' />
                            <span className='nav-text'>Insurance Payers</span>{' '}
                            {!hasAccessOfPlans(`${url}/settings/insurance-payer`) ? (
                              <Icon type='lock' />
                            ) : (
                              ''
                            )}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}
                  </Menu.ItemGroup>
                )}
                {/* } */}

                {(hasAccessOf('Subscription') ||
                  hasAccessOf('TeamMembers') ||
                  hasAccessOf('Activity')) && (
                  <Menu.ItemGroup
                    key='administration-section'
                    title={
                      <span className='isoMenuHolder' style={submenuColor}>
                        <BTIcon type='administration' />
                        <span className=''>Administration</span>
                      </span>
                    }
                  >
                    {hasAccessOf('Subscription') && (
                      <Menu.Item
                        style={submenuStyle}
                        key={`${url}/subscription`}
                        hidden={this.isLockVisible(`${url}/subscription`)}
                      >
                        <Link to={`${url}/subscription`}>
                          <span className='isoMenuHolder anticon' style={submenuColor}>
                            <BTIcon type='subscription' />
                            <span className='nav-text'>Subscription</span>{' '}
                            {!hasAccessOfPlans(`${url}/subscription`) ? <Icon type='lock' /> : ''}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}
                    {isOwner() ? (
                      <Menu.Item style={submenuStyle} key={`${url}/team_members`}>
                        <Link to={`${url}/team_members`}>
                          <span className='isoMenuHolder anticon' style={submenuColor}>
                            <BTIcon type='teamMembers' />
                            <span className='nav-text'>Team Members</span>
                          </span>
                        </Link>
                      </Menu.Item>
                    ) : (
                      ''
                    )}
                    {hasAccessOf('Activity') && (
                      <Menu.Item
                        style={submenuStyle}
                        hidden={this.isLockVisible(`${url}/account-activity`)}
                        key={`${url}/account-activity`}
                      >
                        <Link to={`${url}/account-activity`}>
                          <span className='isoMenuHolder anticon' style={submenuColor}>
                            <BTIcon type='accountActivity' />
                            <span className='nav-text'>Account Activity</span>{' '}
                            {!hasAccessOfPlans(`${url}/account-activity`) ? (
                              <Icon type='lock' />
                            ) : (
                              ''
                            )}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}
                  </Menu.ItemGroup>
                )}
                {/* </Fragment>
                } */}
                <Menu.Item key='/help'>
                  <a href='https://help.swasth.co/' target='_blank' rel='noreferrer'>
                    <span className='isoMenuHolder anticon' style={submenuColor}>
                      <Icon type='reconciliation' />
                      <span className='nav-text'>Help</span>
                    </span>
                  </a>
                </Menu.Item>
              </Menu>
            )}
          </Scrollbars>
        </Sider>
      </SidebarWrapper>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      app: state.App.toJS(),
    }),
    { toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed },
  )(Sidebar),
);

// <Menu.Item key="coverage">
//   <Link to={`${url}/coverage`}>
//     <span className="isoMenuHolder" style={submenuColor}>
//       <i className="ion-checkmark" />
//       <span className="nav-text">
//         Coverage
//         </span>
//     </span>
//   </Link>
// </Menu.Item>
